import {post} from '../script/serviceApiPost';

export default{
  async save(requestParam: any) {
    const result = await post('updateLog/save', requestParam);
    return result;
  },
  async removeByIds(requestParam: any) {
    const result = await post('updateLog/removeByIds', requestParam);
    return result;
  },
  async updateById(requestParam: any) {
    const result = await post('updateLog/updateById', requestParam);
    return result;
  },
  async getById(requestParam: any) {
    const result = await post('updateLog/getById', requestParam);
    return result;
  },
  async selectPageData(requestParam: any) {
    const result = await post('updateLog/selectPageData', requestParam);
    return result;
  },
 
};
